module.exports = "/images/pin-vehiculo.svg?299d0ded7a769bc4cd7761555375d3f4";